import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.78087 6.3753C2.43586 5.94404 1.80657 5.87412 1.3753 6.21913C0.944043 6.56414 0.874122 7.19343 1.21913 7.6247L2.78087 6.3753ZM6 12L5.21913 12.6247C5.39682 12.8468 5.66069 12.9827 5.9447 12.9985C6.22871 13.0142 6.50598 12.9082 6.70711 12.7071L6 12ZM14.7071 4.70711C15.0976 4.31658 15.0976 3.68342 14.7071 3.29289C14.3166 2.90237 13.6834 2.90237 13.2929 3.29289L14.7071 4.70711ZM1.21913 7.6247L5.21913 12.6247L6.78087 11.3753L2.78087 6.3753L1.21913 7.6247ZM6.70711 12.7071L14.7071 4.70711L13.2929 3.29289L5.29289 11.2929L6.70711 12.7071Z",
		fill: "#71747E"
	})
});
export default SvgTick;
